import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as g from 'src/app/globals';

@Injectable({
  providedIn: 'root',
})
export class MediaService {
  constructor(private http: HttpClient) {}

  submitData(data: string, fileNamePrefix: string, saveToImages: boolean = false) {
    const prefix = data.split(',')[0];
    const mimeType = prefix.split(';')[0].replace('data:', '');
    const imageData = data.split(',')[1];

    return this.http.post(`${g.apiBaseUrl}media/saveMedia`, { mimeType, imageData, fileNamePrefix, saveToImages });
  }
}
